import React, { FC } from 'react';

import { CDN_IMG_URL_REGEX } from '../../../../../constants';
import { StyledImage } from './styled';

export const ClientLogo: FC<{ url: string | undefined }> = ({ url }) => {
  if (!url || !CDN_IMG_URL_REGEX.test(url)) {
    return null;
  }

  return <StyledImage src={url} alt="Logo" />;
};
